import React, { useEffect, Fragment, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import './style.scss';
import TallyIntegrationActions from '@Actions/integrations/tallyIntegrationActions';
import Helpers from '@Apis/helpers';
import { Image } from 'antd';
import TallyPng from '@Images/admin/integrations/tally.png';
import StepInfo from './StepsInfo';
import TallyInstall from './Steps/TallyInstall';
import TallyMapLocations from './Steps/TallyMapLocations';
import TallySuccess from './Steps/TallySuccess';
import TallyMapUOM from './Steps/TallyMapUOM';
import TallyMapPurchaseTaxes from './Steps/TallyMapPurchaseTaxes';
import TallyMapSalesTaxes from './Steps/TallyMapSalesTaxes';
import AccountSetup from './Steps/AccountSetup';
import SyncData from './Steps/SyncData';
import TallyTabLoading from './tallyTabLoading';
import TallyTcsAndTdsMapping from './Steps/TallyTcsAndTdsMapping';
import TallyAddressTypes from './Steps/TallyAddressTypes';
import '../../../../../scss/integration.scss';
import TallyMapPurchaseCharges from './Steps/TallyMapPurchaseCharges';
import TallyMapSalesCharges from './Steps/TallyMapSalesCharges';

const tallyIntegrationTabs = [{
  stepNumber: 1,
  component: TallyInstall,
  stepName: 'Install Tally',
}, {
  stepNumber: 2,
  component: TallyMapLocations,
  stepName: 'Map Locations',
}, {
  stepNumber: 3,
  component: AccountSetup,
  stepName: 'Configuration',
}, {
  stepNumber: 4,
  component: TallyMapUOM,
  stepName: 'Setup Import/Export UOM',
}, {
  stepNumber: 5,
  component: TallyMapPurchaseTaxes,
  stepName: 'Map Purchase Taxes',
}, {
  stepNumber: 6,
  component: TallyMapPurchaseCharges,
  stepName: 'Map Purchase Charges',
}, {
  stepNumber: 7,
  component: TallyMapSalesTaxes,
  stepName: 'Map Sales Taxes',
}, {
  stepNumber: 8,
  component: TallyMapSalesCharges,
  stepName: 'Map Sales Charges',
}, {
  stepNumber: 9,
  component: TallyTcsAndTdsMapping,
  stepName: 'Map TCS and TDS Taxes',
}, {
  stepNumber: 10,
  component: TallyAddressTypes,
  stepName: 'Tally Address Types',
}, {
  stepNumber: 11,
  component: SyncData,
  stepName: 'Sync Data',
}, {
  stepNumber: 12,
  component: TallySuccess,
  stepName: 'Review & Save',
}];

const TallySetup = ({
  user, getTallyConnections, getTallyConnectionsLoading, getTenantsLoading, history,
}) => {
  const [step, setStepState] = useState('6');
  const [integrationTallyId, setIntegrationTallyId] = useState('');
  const [selectedTallyConnection, setSelectedTallyConnection] = useState('');

  function setStep(_step, _integrationTallyId) {
    _integrationTallyId = _integrationTallyId || integrationTallyId;
    setStepState(_step);
    history.push(`/admin/integration/tally/setup?it_id=${_integrationTallyId}&step=${_step}`);
  }

  useEffect(() => {
    getTallyConnections(user?.tenant_info?.org_id, (connections) => {
      const integrationTallyIdURL = Number(Helpers.getValueFromUrl('it_id'));
      const newConnection = Helpers.getValueFromUrl('is_create_flow');
      setIntegrationTallyId(integrationTallyIdURL);
      const urlStepNumber = Number(Helpers.getValueFromUrl('step'));
      const tallyConnection = connections?.find((connection) => connection?.it_id === integrationTallyIdURL);
      setSelectedTallyConnection(tallyConnection);
      if (tallyConnection && urlStepNumber) {
        setStep(urlStepNumber, integrationTallyIdURL);
      } else if (tallyConnection && tallyConnection?.locations?.length) {
        setStep(2, integrationTallyIdURL);
      } else if (tallyConnection && !tallyConnection?.locations?.length) {
        setStep(1, integrationTallyIdURL);
      } else if (!tallyConnection || newConnection) {
        setStep(1, 'new');
        // history.push('/admin/integration/tally/setup?it_id=new');
      } else {
        history.push('/admin/integration/tally');
      }
    });
  }, []);

  const selectedTab = tallyIntegrationTabs.find((i) => i.stepNumber === step);
  return (
    <Fragment>
      <div className="integration-home__wrapper">
        <div className="integration-home__header">
          <div className="flex-display flex-align-c">
            <Image src={TallyPng} className="integration-home__heading" preview={false} />
            &nbsp;
            Tally Accounting
          </div>
        </div>
        <div className="ant-row">
          <div className="ant-col-md-5">
            <StepInfo step={step} tallyIntegrationTabs={tallyIntegrationTabs} loading={getTallyConnectionsLoading || getTenantsLoading} />
          </div>
          {(getTallyConnectionsLoading || !selectedTab) ? <TallyTabLoading /> : (
            <div className="ant-col-md-19 tally-int__content">
              {selectedTab && <selectedTab.component setStep={(_s) => setStep(_s)} stepNumber={selectedTab.stepNumber} tallyConnection={selectedTallyConnection} />}
            </div>
          )}
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = ({ UserReducers }) => ({
  user: UserReducers.user,

});

const mapDispatchToProps = (dispatch) => ({
  getTallyConnections: (orgId, callback) => dispatch(TallyIntegrationActions.getTallyConnections(orgId, callback)),
});

TallySetup.propTypes = {
  user: PropTypes.any,
  history: PropTypes.any,
  getTallyConnectionsLoading: PropTypes.bool,
  getTenantsLoading: PropTypes.bool,
  getTallyConnections: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(TallySetup));
